var path = 'app/scripts/modules/titus/src/serverGroup/details/scalingPolicy/popover/scalingPolicyDetails.popover.html';
var html = "<aws-scaling-policy-popover policy=\"$ctrl.policy\" server-group=\"$ctrl.alarmServerGroup\"></aws-scaling-policy-popover>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;